import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';
import '../styles/Notifications.css';

function timeAgo(iso) {
  const now = new Date();
  const then = new Date(iso);
  const seconds = Math.floor((now - then) / 1000);

  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return then.toLocaleDateString();
}

function iconForType(type) {
  switch (type) {
    case 'new_match':
      return '🎉';
    case 'new_message':
      return '💬';
    case 'new_like':
      return '💗';
    case 'system':
      return '🔔';
    default:
      return '🔔';
  }
}

export default function NotificationsPage() {
  const navigate = useNavigate();
  const {
    notifications,
    unreadCount,
    loading,
    markAsRead,
    markAllAsRead,
  } = useNotifications();

  const handleClick = async (notif) => {
    if (!notif.read_at) {
      await markAsRead(notif.id);
    }

    // Route to relevant screen based on type + payload
    const data = notif.data || {};
    if (notif.type === 'new_match' && data.match_id) {
      navigate('/matches');
    } else if (notif.type === 'new_message' && data.match_id) {
      navigate(`/chat/${data.match_id}`);
    } else if (notif.type === 'new_like') {
      // Premium feature - takes them to discover for now
      navigate('/likes');
    }
  };

  return (
    <div className="notifications-page">
      <header className="notifications-header">
        <button
          className="back-btn"
          onClick={() => navigate(-1)}
          aria-label="Back"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <h1>Notifications</h1>
        {unreadCount > 0 && (
          <button className="mark-all-btn" onClick={markAllAsRead}>
            Mark all read
          </button>
        )}
        {unreadCount === 0 && <div className="header-spacer" />}
      </header>

      <main className="notifications-list">
        {loading && notifications.length === 0 && (
          <div className="empty-state">
            <p>Loading...</p>
          </div>
        )}

        {!loading && notifications.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🔕</div>
            <h3>No notifications yet</h3>
            <p>When someone matches with you or sends a message, you'll see it here.</p>
          </div>
        )}

        {notifications.map((n) => (
          <button
            key={n.id}
            className={`notification-item ${!n.read_at ? 'unread' : ''}`}
            onClick={() => handleClick(n)}
          >
            <div className="notification-icon">{iconForType(n.type)}</div>
            <div className="notification-body">
              <div className="notification-title">{n.title}</div>
              <div className="notification-text">{n.body}</div>
              <div className="notification-time">{timeAgo(n.created_at)}</div>
            </div>
            {!n.read_at && <div className="notification-dot" />}
          </button>
        ))}
      </main>
    </div>
  );
}